import { preload } from "swr";
import { fetchTrendingConfig } from "~/api/endpoints";

export const trendingLoader = () => {
    preload("fetchTrendingConfig", fetchTrendingConfig);
    return true;
};
